import { APICore } from './apiCore';

const api = new APICore();

function eventbookingCommentList(): any {
    const baseUrl = '/eventbooking_comments';
    return api.getWithoutQuery(`${baseUrl}`, { headers: { 'Content-Type': 'application/json', Accept: "*/*", Authorization: `Bearer ${api.getLoggedInUser().token}` }});
}

function eventbookingCommentUpdateStatus(requestBody): any {
    const baseUrl = '/eventbookings/' + requestBody.eventbooking_id + '/eventbooking_comments/update_message_status';
    return api.update(`${baseUrl}`, {}, { headers: { 'Content-Type': 'application/json', Accept: "*/*" }});
}

function eventbookingCommentCreate(requestBody): any {
    const baseUrl = '/eventbookings/' + requestBody.id + '/eventbooking_comments/create_message';
    return api.create(`${baseUrl}`, requestBody.data, { headers: { 'Content-Type': 'application/json', Accept: "*/*" }});
}

function eventbookingCommentUpdate(requestBody) {
    const baseUrl = '/eventbooking_comments/' + requestBody.id + '/update_message';
    return api.update(`${baseUrl}`, requestBody.data, { headers: { 'Content-Type': 'application/json', Accept: "*/*" }});
}

function eventbookingCommentDelete(requestBody) {
    const baseUrl = '/eventbooking_comments/' + requestBody.id + '/delete_message';
    return api.delete(`${baseUrl}`, { headers: { 'Content-Type': 'application/json', Accept: "*/*" }});
}

export { eventbookingCommentList, eventbookingCommentUpdateStatus, eventbookingCommentCreate, eventbookingCommentUpdate, eventbookingCommentDelete };